//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('docArticleTopUserGroups', {
//        templateUrl: 'views/components/views/docArticleTopUserGroups/docArticleTopUserGroups.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'docArticleTopUserGroupsService', function ($stateParams, docArticleTopUserGroupsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let docArticleKeynoTop = $stateParams.docarticle_keyno_top;
            
//    		vm.model = {
//    			itemsListUserGroups: []
//    		};

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadTopUserGroups() {
//                vm.model.itemsListUserGroups = await docArticleTopUserGroupsService.listTopUserGroups({ docarticle_keyno_top: docArticleKeynoTop });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadTopUserGroups();
//            }

//            // #endregion ON INIT FUNCTION

//    	}]
//    });
//})();
